import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { Device } from './bots.component';

@Component({
  selector: 'app-delete-bot-dialog',
  templateUrl: './delete-bot-dialog.component.html',
  styleUrls: ['./delete-bot-dialog.component.scss'],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
  ],
  standalone: true,
})
export class DeleteBotDialogComponent {
  confirmationInput = '';

  get requiredWord(): string {
    return this.device.name.slice(0, 10);
  }

  get isConfirmed(): boolean {
    return this.confirmationInput === this.requiredWord;
  }

  constructor(
    public dialogRef: MatDialogRef<DeleteBotDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public device: Device,
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    if (this.isConfirmed) {
      this.dialogRef.close(true);
    }
  }
}
